import React from 'react';
import { BandMember } from '../types';
import '../styles/components/BandMemberCard.css';

interface BandMemberCardProps {
  member: BandMember;
  showFullContent?: boolean;
}

const BandMemberCard: React.FC<BandMemberCardProps> = ({ member, showFullContent = false }) => {
  return (
    <div className="member-card">
      {member.profilePhoto && (
        <div className="member-photo-container">
          <img 
            src={member.profilePhoto} 
            alt={member.name} 
            className="member-photo"
          />
        </div>
      )}
      <div className="member-header">
        <h3 className="member-name">{member.name}</h3>
      </div>
      <div className="member-instruments">
        <div className="instrument-pills">
          {member.instruments.map((instrument, index) => (
            <span key={index} className="instrument-pill">
              {instrument}
            </span>
          ))}
        </div>
      </div>
      {showFullContent && (
        <>
          <div className="member-bio">
            <p>{member.bio}</p>
          </div>
          {member.socialMedia && (
            <div className="member-social-links">
              {member.socialMedia.youtube && (
                <a href={member.socialMedia.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <i className="fab fa-youtube"></i>
                </a>
              )}
              {member.socialMedia.twitch && (
                <a href={member.socialMedia.twitch} target="_blank" rel="noopener noreferrer" aria-label="Twitch">
                  <i className="fab fa-twitch"></i>
                </a>
              )}
              {member.socialMedia.spotify && (
                <a href={member.socialMedia.spotify} target="_blank" rel="noopener noreferrer" aria-label="Spotify">
                  <i className="fab fa-spotify"></i>
                </a>
              )}
              {member.socialMedia.twitter && (
                <a href={member.socialMedia.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
              )}
              {member.socialMedia.facebook && (
                <a href={member.socialMedia.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <i className="fab fa-facebook"></i>
                </a>
              )}
              {member.socialMedia.instagram && (
                <a href={member.socialMedia.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BandMemberCard;
